import React from 'react'

const Twenty_seven = () => {
    return (
        <div className='container'>
            <h1>Find Mean</h1>
            <div className='containers'>
            Mean is an average value of given set of numbers. It is calculated similar 
            to that of average value. Adding all given number together and then dividing
             them by the total number of values produces mean.  <br />
             Mean of 3, 5, 2, 7, 3 is (3 + 5 + 2 + 7 + 3) / 5 = 4.
             </div>
               <h3>Logic to find mean </h3>
               START <br />
   Step 1 → Take an integer set A of n values <br />
   Step 2 → Add all values of A together <br />
   Step 3 → Divide result of Step 2 by n <br />
   Step 4 → Result is mean of A's values <br />
STOP <br />
<div className='containers'>
<code className='library'> #include</code> &lt;stdio.h&gt;<br/>



<code className='keywords'>int </code> main() &#123;<br/>
<code className='keywords'>float</code> mean;<br/>
<code className='keywords'> int</code> sum, i;<br/>
<code className='keywords'> int </code>n = 5;<br/>
<code className='keywords'> int </code>a[] = &#123;2,6,7,4,9&#125;;<br/>

   sum = 0;<br/>

   <code className='keywords'> for</code>(i = 0; i &lt; n; i++&gt;<br/>
    &#123;<br/>
      sum+=a[i];<br/>
   &#125;<br/>

   <code className='library'>printf</code>("Mean = %f ", sum/(float)n);<br/>

   <code className='library'> return </code>0;<br/>
&#125;<br/>
</div>
        </div>
    )
}

export default Twenty_seven
